<template>

  <v-chip outlined small :color="config.color" v-if="type === 'chip'">{{ config.title }}</v-chip>
  <span v-else :class="config.color + '--text'">{{ config.title }}</span>

</template>

<script>
  export default {
    name: 'alarm-status',
    props: [ 'alarm', 'type' ],

    computed: {
      config () {
        if (this.alarm.status === 'pending')
          return { title: this.$t('alarms.status.pending'), color: 'red' }

        if (this.alarm.status === 'inProgress')
          return { title: this.$t('alarms.status.in-progress'), color: 'orange' }

        if (this.alarm.status === 'resolved')
          return { title: this.$t('alarms.status.resolved'), color: 'green' }

        if (this.alarm.status === 'closed')
          return { title: this.$t('alarms.status.closed'), color: 'green' }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
